import {
    UPDATE_DOMAINS_REQUEST,
    UPDATE_DOMAINS_SUCCESS,
    UPDATE_DOMAINS_PARTIAL_SUCCESS,
    UPDATE_DOMAINS_FAILURE,
} from './types/domain-management-action-types';

import {
    openDomainManagementBulkSuccessSnackbar,
    openDomainManagementBulkErrorSnackbar,
} from '../actions/snackbar-action-creators';

import { fetchDomainsOverview } from '../actions/domains-overview-action-creators';
import { refreshClaimedDomains } from '../../system/actions/claimed-domains-action-creators';
import { refreshUnclaimedDomains } from '../../system/actions/unclaimed-domains-action-creators';

import MimirService from '../services/mimir-service';

function updateDomainsBulkRequest(){
    return {
        type: UPDATE_DOMAINS_REQUEST
    };
}
function updateDomainsBulkSuccess( { domainsById, allIds, successfulDomains } ){
    return {
        allIds,
        domainsById,
        successfulDomains,
        type: UPDATE_DOMAINS_SUCCESS,
    };
}

function updateDomainsBulkPartialSuccess( { allIds, domainErrors, domainsById, successfulDomains } ){
    return {
        allIds,
        domainErrors,
        domainsById,
        successfulDomains,
        type: UPDATE_DOMAINS_PARTIAL_SUCCESS,
    };
}

function updateDomainsBulkFailure( error = null ){
    return {
        error,
        type: UPDATE_DOMAINS_FAILURE,
    };
}

function formatDomainsBulkMetaData( metadata ){
    let domainErrors = {};
    if( metadata.failedDomains ){
        domainErrors['failedDomains'] = metadata.failedDomains;
    }

    if( metadata.alreadyClaimedDomains ){
        domainErrors['alreadyClaimedDomains'] = metadata.alreadyClaimedDomains;
    }

    if( metadata.invalidDomains ){
        domainErrors['invalidDomains'] = metadata.invalidDomains;
    }

    if( metadata.unclaimedDomains ){
        domainErrors['unclaimedDomains'] = metadata.unclaimedDomains;
    }

    return domainErrors;
}

function domainsBulkResponseHelper( dispatch, response, domainActionType, domainType ){
    const { domainsById, allIds, data: { data, metadata }, status } = response;
    const successfulDomains = data;

    const domainErrors = formatDomainsBulkMetaData( metadata );

    if( status >= 400 ){
        dispatch( openDomainManagementBulkErrorSnackbar( domainActionType ) );
    }
    else if( status >= 200 ){
        // Refresh domains overview data and claimed domains
        // Some domains might get added even on a failure
        dispatch( fetchDomainsOverview() );
        dispatch( refreshClaimedDomains() );
        dispatch( refreshUnclaimedDomains() );

        if( status === 207 && Object.keys( domainErrors ).length > 0 ){
            dispatch( updateDomainsBulkPartialSuccess( { allIds, domainErrors, domainsById, successfulDomains } ) );
        }
        else{
            dispatch(
                updateDomainsBulkSuccess(
                    {
                        allIds,
                        domainsById,
                        successfulDomains,
                    }
                )
            );
            const successfulDomainsTotal = successfulDomains.length || 0;
            dispatch( openDomainManagementBulkSuccessSnackbar( successfulDomainsTotal, domainActionType, domainType ) );
        }
    }
}

function updateDomainsBulk( actionType, domains, domainType ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( updateDomainsBulkRequest() );

        const api = new MimirService( DATA_API );
        const requestMap = {
            add: api.addDomainsBulk,
            changeType: api.editDomainsBulk,
            claim: api.editDomainsBulk,
            remove: api.removeDomainsBulk
        };

        return requestMap[actionType]( domains, domainType ).then(
            ( response ) => {
                domainsBulkResponseHelper( dispatch, response, actionType, domainType );
            },
            ( error ) => {
                dispatch( updateDomainsBulkFailure( error ) );
                dispatch( openDomainManagementBulkErrorSnackbar( actionType ) );
            },
        );
    };
}

export function addDomains( domains, domainType ){
    return ( dispatch ) => dispatch( updateDomainsBulk( 'add', domains, domainType ) );
}

export function claimDomains( domains, domainType ){
    return ( dispatch ) => dispatch( updateDomainsBulk( 'claim', domains, domainType ) );
}

export function changeDomainType( domains, domainType ){
    return ( dispatch ) => dispatch( updateDomainsBulk( 'changeType', domains, domainType ) );
}

export function removeDomains( domains ){
    return ( dispatch ) => dispatch( updateDomainsBulk( 'remove', domains ) );
}

